import React from "react";
import { getPriorityMeta } from "./reportingStyles";

function PriorityBadge({ priority }) {
  if (!priority) return <span className="text-xs text-slate-300">—</span>;
  const meta = getPriorityMeta(priority);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded px-1.5 py-0.5 text-[11px] font-medium ${meta.bg} ${meta.text}`}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: meta.dot }} />
      {meta.label}
    </span>
  );
}

export default PriorityBadge;